import { z } from 'zod'

import noLeadingSpaces from '../../utilities/noLeadingSpaces'

export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png']
// const MAX_FILE_SIZE = 100000000

const passerror =
  'Password should contain at least one uppercase letter, one lowercase letter, one digit, and one special character, with a minimum length of eight characters, and must not contain any spaces.'

export const formSchema = z.object({
  name: z
    .string({ invalid_type_error: 'Required.' })
    .min(1, { message: 'Required.' })
    .refine(noLeadingSpaces, {
      message: 'Leading spaces are not allowed',
    }),

  accounting_app: z.string().nullable().optional(),

  accounting_app_id: z.string().nullable().optional(),

  phone: z
    .string()
    .refine(
      (value) =>
        value === '' ||
        /^(\+?\d{1,4}[\s-]?)?(\d{10}|\d{3}[\s-]?\d{3}[\s-]?\d{4}|\d{4}[\s-]?\d{3}[\s-]?\d{3})$/.test(
          value
        ),
      {
        message: 'Invalid phone number.',
      }
    )
    .refine(noLeadingSpaces, {
      message: 'Leading spaces are not allowed',
    }),
  // email: z
  //   .string()
  //   .min(5, { message: 'Required' }) // Ensure at least 5 characters
  //   .superRefine((value, ctx) => {
  //     if (value !== '') {
  //       // Updated regex to allow '+' in the user part of the email and support modern/longer TLDs
  //       if (!/^[\w-.+]+@([\w-]+\.)+[\w-]{2,}$/.test(value)) {
  //         ctx.addIssue({
  //           code: z.ZodIssueCode.custom,
  //           message: 'Invalid email format.',
  //         })
  //       }
  //     }
  //   })
  //   .refine(noLeadingSpaces, {
  //     message: 'Leading spaces are not allowed',
  //   }),

  // password: z
  //   .string({ required_error: 'Required' })
  //   .regex(new RegExp(/^[^\s]*$/), { message: 'Space not allowed' })
  //   .regex(new RegExp('.*[A-Z].*'), { message: passerror })
  //   .regex(new RegExp('.*[a-z].*'), { message: passerror })
  //   .regex(new RegExp('.*\\d.*'), { message: passerror })
  //   .regex(new RegExp('.*[`~<>?,./!@#$%^&*()\\-_+="\'|{}\\[\\];:\\\\].*'), {
  //     message: passerror,
  //   })
  //   .min(8, { message: passerror }),
  // .optional(),
  password: z
    .string()
    // .min(8, { message: passerror })
    .optional()
    .refine((val) => /^[^\s]*$/.test(val as string), {
      message: 'Space not allowed',
    })
    .refine((val) => !val || /^[^\s]*$/.test(val), { message: passerror })
    .refine((val) => !val || /.*[A-Z].*/.test(val), { message: passerror })
    .refine((val) => !val || /.*[a-z].*/.test(val), { message: passerror })
    .refine((val) => !val || /.*\d.*/.test(val), { message: passerror })
    .refine(
      (val) => !val || /.*[`~<>?,./!@#$%^&*()\-_=+"'\|{}\[\];:\\].*/.test(val),
      { message: passerror }
    )
    .refine((val) => !val || val.length >= 8, { message: passerror }),
  confirm_password: z.string().optional(),
  old_password: z.string().optional(),

  // confirm_password: z
  //   .string({ required_error: 'Required' })
  //   .min(1, { message: 'Required.' }),
  // old_password: z
  //   .string({ required_error: 'Required' })
  //   .min(1, { message: 'Required.' }),
  reset_password: z.preprocess(
    (val) => val === 'true' || val === true,
    z.boolean()
  ),
  // password: z
  //   .string()
  //   .optional()
  //   .refine((val) => /^[^\s]*$/.test(val as string), {
  //     message: 'Space not allowed',
  //   })
  //   .refine((val) => !val || /^[^\s]*$/.test(val), { message: passerror })
  //   .refine((val) => !val || /.*[A-Z].*/.test(val), { message: passerror })
  //   .refine((val) => !val || /.*[a-z].*/.test(val), { message: passerror })
  //   .refine((val) => !val || /.*\d.*/.test(val), { message: passerror })
  //   .refine(
  //     (val) => !val || /.*[`~<>?,./!@#$%^&*()\-_=+"'\|{}\[\];:\\].*/.test(val),
  //     { message: passerror }
  //   )
  //   .refine((val) => !val || val.length >= 8, { message: passerror }),
})

// export const myProfileSchema = formSchema.refine(
//   (data) => {
//     if (data.password && data.confirm_password) {
//       if (data.password === data.confirm_password) {
//         return true
//       } else {
//         return false
//       }
//     }
//     return true // If either field is empty, treat as valid to avoid pre-emptive error
//   },
//   {
//     message: 'Passwords do not match',
//     path: ['confirm_password'],
//   }
// )

// export const editFormSchema = profileSchema.omit({
//   password: true,
//   confirm_password: true,
// })

export const myProfileSchema = formSchema.superRefine((data, ctx) => {
  if (data.password && data.confirm_password) {
    if (data.password !== data.confirm_password) {
      ctx.addIssue({
        code: 'custom',
        message: 'Passwords do not match',
        path: ['confirm_password'],
      })
    }
  }
})

export const changePasswordSchema = z.object({
  new_password: z
    .string({ required_error: passerror })
    .regex(new RegExp(/^[^\s]*$/), { message: 'Space not allowed' })
    .regex(new RegExp('.*[A-Z].*'), {
      message: passerror,
    })
    .regex(new RegExp('.*[a-z].*'), {
      message: passerror,
    })
    .regex(new RegExp('.*\\d.*'), {
      message: passerror,
    })
    .regex(new RegExp('.*[`~<>?,./!@#$%^&*()\\-_+="\'|{}\\[\\];:\\\\].*'), {
      message: passerror,
    })
    .min(8, {
      message: passerror,
    }),
})

export type MyProfileSchema = z.infer<typeof myProfileSchema>
// export type ChangePasswordSchema = z.infer<typeof changePasswordSchema>
// export type EditFormSchema = z.infer<typeof editFormSchema>
